'use strict';

module.exports = require( 'ck-core/source/functions/makeLang' )( {
	HEADER: `${CK.config.name === 'ck-coolmath' ? 'Coolmath Coding is designed for Minecraft Java Edition' : 'We are compatible with Minecraft Java Edition'}`,
	BLURB: `The code editor works in any modern web browser. You'll need a copy of Minecraft Java edition to be able to test your code. You can get Minecraft Java Edition on any Windows, Mac or Linux computer from <a href="https://minecraft.net">here</a>.`,
	EDITIONS: [ {
			NAME: 'Java Edition (Windows/Mac)',
			ICON: 'tick-green'
		},
		{
			NAME: 'Bedrock Edition (Tablets/Consoles)',
			ICON: 'status-invalid'
		}
	]
} );
